import styled from 'styled-components'

import Flex from 'Components/UI/Flex'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

const WrapperWide = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
  })
  .withConfig({
    shouldForwardProp,
  })``

export default WrapperWide
